import { Injectable, Signal } from '@angular/core';
import { AbstractDeviceCallLogsFacade } from '@iot-platform/feature/device-call-logs';
import { DeviceCallLog } from '@iot-platform/models/common';
import { Device } from '@iot-platform/models/i4b';
import { Store } from '@ngrx/store';
import { noop } from 'rxjs';
import { DeviceCallLogsActions } from '../actions';
import * as fromDeviceCallLogs from '../reducers/device-call-logs.reducer';
import { DeviceCallLogsSelectors } from '../selectors/device-call-logs.selectors';

/* eslint-disable @angular-eslint/prefer-inject */
@Injectable({
  providedIn: 'root'
})
export class DeviceCallLogsFacade extends AbstractDeviceCallLogsFacade<Device> {
  deviceCallLogMessage: Signal<string> = this.store.selectSignal(fromDeviceCallLogs.deviceCallLogsFeature.selectDeviceCallLogMessage);

  constructor(
    protected override store: Store,
    protected override selector: DeviceCallLogsSelectors
  ) {
    super(store, selector);
  }

  getAll() {
    noop();
  }

  setFilters() {
    noop();
  }

  loadDeviceCallLogs(device: Device): void {
    this.store.dispatch(DeviceCallLogsActions.loadDeviceCallLogs({ device }));
  }

  loadDeviceCallLogMessage(device: Device, deviceCallLog: DeviceCallLog): void {
    this.store.dispatch(DeviceCallLogsActions.loadDeviceCallLogMessage({ device, deviceCallLog, download: false }));
  }

  loadAndDownloadDeviceCallLogMessage(device: Device, deviceCallLog: DeviceCallLog): void {
    const selectedDeviceCallLog = this.currentEntity();
    const deviceCallLogMessage = this.deviceCallLogMessage();
    if (deviceCallLog.id !== selectedDeviceCallLog?.id) {
      this.store.dispatch(DeviceCallLogsActions.loadDeviceCallLogMessage({ device, deviceCallLog, download: true }));
    } else if (deviceCallLogMessage) {
      this.store.dispatch(DeviceCallLogsActions.downloadDeviceCallLogMessage({ deviceCallLogMessage }));
    }
  }
}
